import UpdateAssetFormFields from "@/admin/asset/update/form/UpdateAssetFormFields"
import { UpdateAssetFormFragment$key } from "@/admin/asset/update/form/__generated__/UpdateAssetFormFragment.graphql"
import {
  UpdateAssetFormMutation,
  UpdateAssetInput,
} from "@/admin/asset/update/form/__generated__/UpdateAssetFormMutation.graphql"
import { useFormStore } from "@/core/form/store/FormStore"
import Form from "@components/form/Form"
import { displaySuccessToast } from "@components/toast/ToastProvider"
import { DiscoButton } from "@disco-ui"
import { TestIDProps } from "@utils/typeUtils"
import { useFragment } from "react-relay"
import { graphql } from "relay-runtime"

interface Props extends TestIDProps {
  assetKey: UpdateAssetFormFragment$key
  onClose: VoidFunction
}

export type UpdateAssetFormState = UpdateAssetInput

function UpdateAssetForm(props: Props) {
  const { assetKey, onClose, testid = "UpdateAssetForm" } = props

  const asset = useFragment<UpdateAssetFormFragment$key>(
    graphql`
      fragment UpdateAssetFormFragment on Asset {
        id
        name
        ...UpdateAssetFormFieldsFragment
      }
    `,
    assetKey
  )

  const form = useFormStore<UpdateAssetFormMutation, UpdateAssetFormState>(
    graphql`
      mutation UpdateAssetFormMutation($input: UpdateAssetInput!) {
        response: UpdateAsset(input: $input) {
          node {
            id
            ...AdminMediaLibraryListTableRowFragment
          }
          errors {
            field
            message
          }
        }
      }
    `,
    {
      id: asset.id,
      name: asset.name,
    }
  )

  return (
    <Form
      id={testid}
      testid={testid}
      onSubmit={handleSubmit}
      buttons={
        <>
          <DiscoButton
            color={"grey"}
            variant={"outlined"}
            onClick={onClose}
            testid={`UpdateAssetForm.cancel-button`}
          >
            {"Cancel"}
          </DiscoButton>
          <Form.SubmitButton form={form} id={testid} testid={`${testid}.submit-button`}>
            {"Save Changes"}
          </Form.SubmitButton>
        </>
      }
    >
      <UpdateAssetFormFields form={form} assetKey={asset} />
    </Form>
  )

  async function handleSubmit() {
    const { didSave, response } = await form.submit({
      id: form.state.id,
      name: form.state.name,
    })

    if (!didSave || !response?.node) return

    displaySuccessToast({
      testid: `${testid}.success-toast`,
      message: "Asset updated!",
    })

    onClose()
  }
}

export default UpdateAssetForm
